import {createRouter, createWebHistory} from 'vue-router';

import HomeComponent from '@/components/views/HomeComponent.vue';
import LoginComponent from '@/components/views/auth/LoginComponent.vue';
import RegisterComponent from "@/components/views/auth/RegisterComponent.vue";
import LinksComponent from "@/components/views/links/LinksComponent.vue";
import LinkUpdatedComponent from "@/components/views/links/LinkUpdatedComponent.vue";
import CreateShortLinkComponent from "@/components/views/links/CreateShortLinkComponent.vue";
import ShortRedirect from "@/components/views/redirect/ShortRedirect.vue";
import Error404Component from "@/components/views/Error404Component.vue";
import StatisticsAdminComponent from "@/components/views/stastistics/adminStatistics/StatisticsAdminComponent.vue";
import UserStatisticsComponent from "@/components/views/stastistics/userStatistics/UserStatisticsComponent.vue";
import UserComponent from "@/components/views/user/UserComponent.vue";

/**
 * Defines the application's route configuration.
 * Each route maps a URL path to a specific component and includes meta information for dynamic page titles.
 *
 * @type {Array<Object>}
 * @property {string} path The URL path associated with the route.
 * @property {string} name The unique name identifying the route.
 * @property {Object} component The component rendered for the route.
 * @property {Object} meta Additional metadata associated with the route.
 * @property {string} meta.title The dynamic title for the page.
 */
const routes = [

    // Home page
    {path: '/', name: 'Home', component: HomeComponent, meta: { title: 'Home | LinkCurt' }},

    // Login page for existing users
    {path: '/login', name: 'Login', component: LoginComponent, meta: { title: 'Login | LinkCurt' }},

    // Register a new user
    {path: '/register', name: 'Register', component: RegisterComponent, meta: { title: 'Register | LinkCurt' }},

    // User profile page
    {path: '/user', name: 'user', component: UserComponent, meta: { title: 'User | LinkCurt' }},

    // Links created by the user
    {path: '/links', name: 'Links', component: LinksComponent, meta: { title: 'My Links | LinkCurt' }},

    //All links created
    {path: '/adminlinks', name: 'adminlinks', component: LinksComponent, meta: { title: 'Admin Links | LinkCurt' }},

    // Edit link to update it
    {path: '/link', name: 'Link', component: LinkUpdatedComponent, meta: { title: 'Edit Link | LinkCurt' }},

    // Create a new short link
    {path: '/create-link', name: 'create link', component: CreateShortLinkComponent, meta: { title: 'Create Link | LinkCurt' }},

    // Admin statistics
    {path: '/adminStatistics', name: 'adminStatistics', component: StatisticsAdminComponent, meta: { title: 'Admin Statistics | LinkCurt' }},

    // User statistics
    {path: '/statistics', name: 'statistics', component: UserStatisticsComponent, meta: { title: 'Statistics | LinkCurt' }},

    // Redirect to the original link
    {path: '/:shortLink(\\w{4})', name: 'ShortRedirect', component: ShortRedirect, meta: { title: 'Redirect | LinkCurt' }},

    // Page not found
    {path: '/:pathMatch(.*)*', name: 'Error404', component: Error404Component, meta: { title: '404 Not Found | LinkCurt' }},


];

/**
 * Router instance responsible for handling navigation within the application.
 *
 * This router is configured with a history mode using `createWebHistory`,
 * allowing clean URLs without hash (#) symbols, and is initialized with
 * the application's route definitions.
 *
 * The `routes` parameter contains the route configuration array, where each
 * route object defines the mapping between a URL path and its corresponding
 * component or functionality.
 *
 * This instance is used to navigate programmatically or to define navigation
 * guards and resolve routes.
 */
const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Change the document title after each route change
router.afterEach((to) => {
    const defaultTitle = 'LinkCurt';
    document.title = to.meta.title || defaultTitle;
});

export default router;
